import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import ArticleListForm from '@src/features/tenant/articles/ArticleListForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function ArticleList() {
  return (
    <TenantRoleGuard
      canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT]}
      canService={[SERVICE.ENTERPRISE_PORTAL]}
    >
      <TenantDefaultLayout>
        <CommonHelmet />
        <ArticleListForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default ArticleList;
